import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button } from "@mui/material";
import IconDownload from "src/assets/images/icon_download.svg";
import { getFloatValue } from "src/constant";
import { Loader } from "src/components/loader";

export const Monthly = ({ data }) => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const { filterAllData } = useSelector((state) => state.goodsin);
  const lookupValues = useSelector((state) => state.lookup);
  const { isDropdownOpenFlagValue } = useSelector((state) => state.dashboard);
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);

  /** hooks useState ----------------------------------------------------- **/
  const [totalWeeks, setTotalWeeks] = useState([]);
  const [monthlyData, setMonthlyData] = useState([]);
  const [loadingState, setLoadingState] = useState(true)

  /** Variable declarations----------------------------------------------------- **/
  const filterData = filterAllData["report"];
  const clientCount = _.unionBy(_.map(monthlyData || [], (d) => d.client), (d) => d).length;
  const projectCount = _.unionBy(_.map(monthlyData || [], (d) => d.project), (d) => d).length;
  const depotCount = _.unionBy(_.map(monthlyData || [], (d) => d.depotName), (d) => d).length;
  const damagedCount = _.filter(monthlyData || [], (d) => d.condition == "Damaged")?.length || 0;
  let userDetails = JSON.parse(localStorage.getItem("userDetails"))


  /** hooks useEffect----------------------------------------------------- **/

  /** Function to manipulate(creates) data which is shown in the reports tab. ------------------ **/
  const dataManipulationPipe = (data, forFilter) => {
    let uniqByData = _.uniqBy(data, obj => `${obj.projectId}-${obj.depotId}-${obj.clientId}`)
    let result = uniqByData?.map((o, i) => {
      let temp = { ...o };
      let WeeksObject = {};
      let totalInteriorSpaceCount = 0;
      let totalExteriorSpaceCount = 0;
      temp.condition = _.find(lookupValues?.data, (d1) => d1.id === temp?.condition)?.name;
      _.map(totalWeeks, (d1, index) => {
        let filteredData = _.find(
          data,
          (d) =>
            parseInt(d.weekNumber) === parseInt(index + 1) &&
            d.projectId === temp?.projectId && d.depotId === temp?.depotId && d.clientId === temp?.clientId
        );
        WeeksObject[`weekinteriorSpace${index + 1}`] = filteredData?.interiorspace || 0;
        WeeksObject[`weekexteriorSpace${index + 1}`] = filteredData?.exteriorspace || 0;
        totalInteriorSpaceCount = totalInteriorSpaceCount + parseFloat(filteredData?.interiorspace || 0);
        totalExteriorSpaceCount = totalExteriorSpaceCount + parseFloat(filteredData?.exteriorspace || 0);
      });
      return {
        ...o,
        client: temp?.clientName,
        project: temp?.projectName,
        depotName: temp?.depotName,
        depotCode: temp?.depotCode,
        ...WeeksObject,
        interiorRate: temp?.interiorRate || 0,
        exteriorRate: temp?.exteriorRate || 0,
        totalInteriorSpace: totalInteriorSpaceCount,
        interiorCharges: totalInteriorSpaceCount * temp?.interiorRate || 0,
        totalExteriorSpace: totalExteriorSpaceCount,
        exteriorCharges: totalExteriorSpaceCount * temp?.exteriorRate || 0,
        allTotalCharges:
          (totalInteriorSpaceCount * temp?.interiorRate || 0) +
          (totalExteriorSpaceCount * temp?.exteriorRate || 0),
      };
    });
    return result;
  };

  useEffect(() => {
    let setMonthData = dataManipulationPipe(data?.DataTable || []);
    setLoadingState(false)
    setMonthlyData([...setMonthData]);
    setTotalWeeks([...data?.WeekInfoList || []]);

  }, [data]);

  /** Based on selected month and year from dropdown retrieve weeks list --------------------------- **/
  useState(() => {
    let forFilter = true;
    let setMonthDataFilter = dataManipulationPipe(data?.DataTable || [], forFilter);

    setTotalWeeks([...data?.WeekInfoList || []]);
  }, [filterData]);

  const CalculateSum = (filter) => {
    return _.sumBy(monthlyData || [], (d) => parseFloat(d[`${filter}`]));
  };

  const generateHeaders = (tableData, weeksData) => {
    const headers = [
      "CLIENT",
      "PROJECT",
      "DEPOT",
    ];
    _.map(weeksData, (weekNumber) => {
      headers.push(`WEEK ${weekNumber?.weekNumber || 0} INTERNAL SPACE`);
      headers.push(`WEEK ${weekNumber?.weekNumber || 0} EXTERNAL SPACE`);
    });

    headers.push(
      "TOTAL INTERNAL",
      "RATE INTERNAL",
      "CHARGES INTERNAL",
      "TOTAL EXTERNAL",
      "RATE EXTERNAL",
      "CHARGES EXTERNAL",
      "TOTAL"
    );

    return headers;
  };

  const saveExcelFile = (
    tableData,
    dateFromStr,
    dateToStr,
    depotStr,
    clientStr,
    projectStr,
    weeksData
  ) => {
    const headers = generateHeaders(tableData, weeksData);
    let AdminHeaderChanges = [
      ["Date:", `${moment(dateFromStr || totalWeeks[0].startDate).format("DD-MMM-YYYY")}  ${dateToStr || totalWeeks.length ? "To  " + moment(dateToStr || totalWeeks[totalWeeks.length - 1].endDate).format("DD-MMM-YYYY") : ""}`],
      ["Depot:", depotStr?.name || "All Depot"],
      ["Client:", clientStr?.name || "All Client"],
      ["Project:", projectStr?.name || "All Project"]
    ]
    let ProjectManagerHeaderChanges = [
      ["Date:", `${moment(dateFromStr || totalWeeks[0].startDate).format("DD-MMM-YYYY")}  ${dateToStr || totalWeeks.length ? "To  " + moment(dateToStr || totalWeeks[totalWeeks.length - 1].endDate).format("DD-MMM-YYYY") : ""}`],
      ["Client:", clientStr?.name || "All Client"],
      ["Project:", projectStr?.name || "All Project"]
    ]

    let activeheader = userDetails?.roles == "ProjectManager" ? ProjectManagerHeaderChanges : AdminHeaderChanges

    const worksheet = XLSX.utils.aoa_to_sheet([
      ...activeheader,
      [],
      [],
      headers,
      ...tableData.map((d) => {
        const rowData = [
          d.client,
          d.project,
          d.depotName,
        ];

        _.map(weeksData, (weekNumber) => {
          rowData.push(d[`weekinteriorSpace${weekNumber?.weekNumber || 0}`] || 0);
          rowData.push(d[`weekexteriorSpace${weekNumber?.weekNumber || 0}`] || 0);
        });
        rowData.push(
          d.totalInteriorSpace || 0,
          d.interiorRate || 0,
          d.interiorCharges || 0,
          d.totalExteriorSpace || 0,
          d.exteriorRate || 0,
          d.exteriorCharges || 0,
          d.allTotalCharges || 0
        );
        return rowData;
      }),
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    // Generate the Excel file buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Convert buffer to Blob and save the file
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const customFileName = `Monthly report ${moment().format(
      "DD:MMM:YYYY:HH:mm"
    )}.xlsx`;
    saveAs(data, customFileName);
  };

  const Print = () => {
    const depot = filterData?.depotId || "All Depot";
    const client = filterData?.clientId || "All Client";
    const project = filterData?.projectId || "All Project";
    let startData = data?.WeekInfoList[0]?.startDate || moment()
    let endDate = data?.WeekInfoList[data?.WeekInfoList?.length - 1]?.endDate || moment()
    saveExcelFile(
      monthlyData,
      startData,
      endDate,
      depot,
      client,
      project,
      totalWeeks,
    );
  };

  if (loadingState) {
    return <Loader />;
  }
  return (
    <div
      style={{ paddingLeft: 16, background: "#ffffff" }}
      className={`${isDropdownOpenFlagValue == true || signoutModelOpenFlag == true
        ? "add-overlay-for-depot-dropdown"
        : ""
        }`}
    >
      <div
        className="table-responsive"
        // style={{ height: window.innerHeight - 100 }}
      >
        <table
          className="table goodsin-table table-borderless"
          style={{ width: "100%" }}
        >
          <thead className="goodsin-table-header">
            <tr>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  CLIENT
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 300,
                  }}
                >
                  project
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  depot
                </div>
              </th>
              {totalWeeks?.length > 0 &&
                totalWeeks.map((w, i) => {
                  return (
                    <React.Fragment key={i}>
                      <th scope="col" className={`text-uppercase text-primary`}>
                        <div
                          style={{
                            fontFamily: "Montserrat-Regular",
                            fontSize: 12,
                            height: 50,
                            // display: "flex",
                            alignItems: "center",
                            width: 130,
                            position: "relative",
                            borderLeft: "1px solid",
                            paddingLeft: 10,
                          }}
                        >
                          <div >
                            Week {i + 1}
                          </div>
                          <div >
                            From : {moment(w.startDate).format("DD-MM-YYYY")}
                          </div>
                          <div>
                            INT. (m2)
                          </div>
                        </div>
                      </th>
                      <th scope="col" className={`text-uppercase text-primary`}>
                        <div
                          style={{
                            fontFamily: "Montserrat-Regular",
                            fontSize: 12,
                            height: 50,
                            alignItems: "center",
                            width: 130,
                            position: "relative",
                            paddingLeft: 10,
                          }}
                        >
                          <div style={{ height: 14 }}>
                          </div>
                          <div  >
                            To: {moment(w.endDate).format("DD-MM-YYYY")}
                          </div>
                          <div >
                            EXT. (m2)
                          </div>
                        </div>
                      </th>
                    </React.Fragment>
                  );
                })}

              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    borderLeft: "1px solid",
                    paddingLeft: 10,
                    width: 90,
                  }}
                >
                  TOTAL INT. (m2)
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 90,
                  }}
                >
                  RATE INT. (£ / m2 / week)
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 90,
                  }}
                >
                  CHARGES INT. (£)
                </div>
              </th>

              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    borderLeft: "1px solid",
                    paddingLeft: 10,
                    width: 90,
                  }}
                >
                  TOTAL EXT. (m2)
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 90,
                  }}
                >
                  RATE EXT. (£ / m2 / week)
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 90,
                  }}
                >
                  CHARGES EXT. (£)
                </div>
              </th>

              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    borderLeft: "1px solid",
                    paddingLeft: 10,
                    width: 100,
                  }}
                >
                  TOTAL (£)
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="goods-table-body">
            {monthlyData.length > 0 &&
              monthlyData.map((d, index) => {
                return (
                  <tr
                    key={`monthlyReportSA${index}`}
                    className="reports-table-body-style-items-tr"
                  >
                    <th scope="col">
                      {/* <div style={{ fontFamily: "Montserrat-Regular", fontSize: 14, height: d.client.length < 20 ? 30 : 50, display: "flex", alignItems: "center" }}> */}
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          height: 80,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {d.client}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          height: 80,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {d.project}
                      </div>
                    </th>


                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          height: 80,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {d.depotName}
                      </div>
                    </th>
                    {totalWeeks?.length > 0 &&
                      totalWeeks.map((w, i) => {
                        return (
                          <React.Fragment key={i}>

                            <th scope="col">
                              <div
                                style={{
                                  fontFamily: "Montserrat-Regular",
                                  fontSize: 14,
                                  height: 80,
                                  display: "flex",
                                  alignItems: "center",
                                  borderLeft: "1px solid",
                                  paddingLeft: 10,
                                }}
                              >
                                {getFloatValue(
                                  d[`weekinteriorSpace${i + 1}`] || 0
                                )}
                              </div>
                            </th>
                            <th scope="col">
                              <div
                                style={{
                                  fontFamily: "Montserrat-Regular",
                                  fontSize: 14,
                                  height: 80,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {getFloatValue(
                                  d[`weekexteriorSpace${i + 1}`] || 0
                                )}
                              </div>
                            </th>
                          </React.Fragment>
                        );
                      })}

                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          height: 80,
                          display: "flex",
                          alignItems: "center",
                          borderLeft: "1px solid",
                          paddingLeft: 10,
                        }}
                      >
                        {getFloatValue(d?.totalInteriorSpace || 0)}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          height: 80,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {getFloatValue(d?.interiorRate || 0)}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          height: 80,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {getFloatValue(d?.interiorCharges || 0)}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          height: 80,
                          display: "flex",
                          alignItems: "center",
                          borderLeft: "1px solid",
                          paddingLeft: 10,
                        }}
                      >
                        {getFloatValue(d?.totalExteriorSpace || 0)}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          height: 80,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {getFloatValue(d?.exteriorRate || 0)}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          height: 80,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {getFloatValue(d?.exteriorCharges || 0)}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          height: 80,
                          display: "flex",
                          alignItems: "center",
                          borderLeft: "1px solid",
                          paddingLeft: 10,
                        }}
                      >
                        {getFloatValue(d?.allTotalCharges)}
                      </div>
                    </th>
                  </tr>
                );
              })}
          </tbody>
          <tfoot className="goodsin-table-footer-style">
            <tr>
              <td scope="col">
                <div style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}>
                  <div className="footer-count-color">{clientCount}</div>
                  <div className="footer-label-color">Client</div>
                </div>
              </td>
              <td scope="col">
                <div style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}>
                  <div className="footer-count-color">{projectCount}</div>
                  <div className="footer-label-color">Project</div>
                </div>
              </td>

              <td scope="col">
                <div style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}>
                  <div className="footer-count-color">{depotCount}</div>
                  <div className="footer-label-color">Depot</div>
                </div>
              </td>
              {totalWeeks?.length > 0 &&
                totalWeeks.map((w, i) => {
                  return (
                    <React.Fragment key={i}>
                      <td scope="col">
                        <div
                          style={{
                            fontFamily: "Montserrat-Regular",
                            fontSize: 12,
                          }}
                        >
                          <div className="footer-count-color">
                            {getFloatValue(
                              CalculateSum(`weekinteriorSpace${i + 1}`)
                            )}
                          </div>
                          <div className="footer-label-color">
                            Int. (m<sup>2</sup>)
                          </div>
                        </div>
                      </td>
                      <td scope="col">
                        <div
                          style={{
                            fontFamily: "Montserrat-Regular",
                            fontSize: 12,
                          }}
                        >
                          <div className="footer-count-color">
                            {getFloatValue(
                              CalculateSum(`weekexteriorSpace${i + 1}`)
                            )}
                          </div>
                          <div className="footer-label-color">
                            Ext. (m<sup>2</sup>){" "}
                          </div>
                        </div>
                      </td>
                    </React.Fragment>
                  );
                })}

              <td scope="col">
                <div style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}>
                  <div className="footer-count-color">
                    {getFloatValue(CalculateSum("totalInteriorSpace"))}
                  </div>
                  <div className="footer-label-color">
                    Int. (m<sup>2</sup>)
                  </div>
                </div>
              </td>
              <td scope="col">
                <div
                  style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}
                ></div>
              </td>
              <td scope="col">
                <div style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}>
                  <div className="footer-count-color">
                    {" "}
                    &#163;
                    {getFloatValue(CalculateSum("interiorCharges"))}
                  </div>
                  <div className="footer-label-color">Int.</div>
                </div>
              </td>
              <td scope="col">
                <div style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}>
                  <div className="footer-count-color">
                    {getFloatValue(CalculateSum("totalExteriorSpace"))}
                  </div>
                  <div className="footer-label-color">
                    Ext. (m<sup>2</sup>){" "}
                  </div>
                </div>
              </td>
              <td scope="col">
                <div
                  style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}
                ></div>
              </td>
              <td scope="col">
                <div style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}>
                  <div className="footer-count-color">
                    &#163;
                    {getFloatValue(CalculateSum("exteriorCharges"))}{" "}
                  </div>
                  <div className="footer-label-color">Ext.</div>
                </div>
              </td>
              <td scope="col">
                <div style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}>
                  <div className="footer-count-color">
                    {" "}
                    &#163;
                    {getFloatValue(CalculateSum("allTotalCharges"))}
                  </div>
                  <div className="footer-label-color">Total Charges </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="d-flex justify-content-end me-3">
        <Button
          disabled={monthlyData?.length <= 0 ? true : false}
          variant="outlined"
          className={`mt-2 save-report-btn-style ms-2 ${monthlyData.length <= 0 ? "fade-out" : ""
            }`}
          startIcon={
            <img src={IconDownload} width={17} height={17} alt="new"></img>
          }
          type="submit"
          onClick={() => Print()}
        >
          Save Report
        </Button>
      </div>
    </div>
  );
};